<template>
    <v-col class="pr-0 py-0 mb-0">
            <v-row class="mr-0">
                <v-col class="flex-grow-0 pa-0">
                    <v-card
                        flat
                        :width="width"
                        align="center"
                        justify="center"
                        
                    >
                        <span 
                            class="mr-3 text-subtitle-1 green--text"                                         
                        > {{ studentName }}</span>                                 
                        <span 
                            class="text-subtitle-1 green--text"
                        >{{ classId }}</span>
                    </v-card>
                </v-col>
            </v-row>

        <v-row class="mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card                                    
                    :width="width"
                    flat
                >
                    <v-row>
                        <v-col
                            align="center"
                            justify="center"
                            v-for="item in academicPeriod"
                            :key="item.title"
                            class="pa-0"
                        >
                            <div 
                                class="text-caption blue--text font-weight-bold"
                            >{{item.title}}</div>
                            <div 
                                class="text-caption green--text"
                            >{{item.value}}</div>
                        </v-col>
                    </v-row>
                </v-card>                                 
            </v-col>
        </v-row>

        <v-row class="mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card
                    :width="width"
                    flat
                >
                    <div>
                        <v-list class="py-0" dense>
                            <v-list-item
                                v-for="item in recordSummary1"
                                :key="item.title"
                                class="pr-0"
                            >
                                <v-list-item-content class="py-0">
                                    <v-list-item-title 
                                        class="text-caption"
                                    >
                                        {{ item.title }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-card                               
                                    width="150"                                                                                                       
                                    flat
                                >
                                    <v-text-field
                                        disabled
                                        filled
                                        dense
                                        outlined
                                        hide-details
                                        v-model="studentRecord[item.model]"
                                        height="20"
                                        class="text-caption pa-0"
                                        
                                    ></v-text-field>
                                </v-card> 
                            </v-list-item>
                        </v-list>
                    </div>
                                                    
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card flat :width="width">
                    <div class="d-flex pl-4 justify-space-between">
                        <div class="d-flex">
                            <v-card flat width="40">
                                <span class="text-caption">{{ recordSummary2[0].title }}</span>
                            </v-card>

                            <v-card                               
                                width="60"                                                                                                       
                                flat
                            >
                                <v-text-field
                                    v-model="studentRecord[recordSummary2[0].model]"
                                    :disabled="recordSummary2[0].disabled"
                                    :filled="recordSummary2[0].disabled"
                                    @blur="updateRecord" 
                                    @input="checkNumber(recordSummary2[0].model)"
                                    dense 
                                    hide-details="auto" 
                                    outlined 
                                    height="20"
                                    class="text-caption pa-0"
                                    type="number"
                                ></v-text-field>    
                            </v-card>
                        </div> 

                        <div class="d-flex">
                            <v-card flat width="120">
                                <span class="text-caption">{{ recordSummary2[1].title }} : </span>
                                <span class="text-caption">{{ pagination.last_page }}</span>
                            </v-card>
                            
                        </div> 
                    </div>

                    

                    <div class="d-flex pl-4 justify-space-between mt-2">      
                        <div class="d-flex">
                            <v-card flat width="40">
                                <span class="text-caption">{{ recordSummary3[0].title }}</span>
                            </v-card>

                            <v-card                               
                                width="60"                                                                                                       
                                flat
                            >
                                <v-text-field
                                    v-model="studentRecord[recordSummary3[0].model]"
                                    :disabled="recordSummary3[0].disabled"
                                    :filled="recordSummary3[0].disabled"
                                    @blur="updateRecord" 
                                    @input="checkNumber(recordSummary3[0].model)"
                                    dense 
                                    hide-details="auto" 
                                    outlined 
                                    height="20"
                                    class="text-caption pa-0"
                                    type="number"
                                ></v-text-field>    
                            </v-card>
                        </div> 
                        
                        <div class="d-flex">
                            <v-card flat width="120">
                                <span class="text-caption">{{ recordSummary3[1].title }}: </span>
                                <span class="text-caption">{{ rank }}</span>
                            </v-card>
                            
                        </div> 

                    </div>
                    
                    <div class="d-flex pl-4 justify-space-between my-2">
                        <v-card
                            height="60"
                            width="90"
                            flat
                            outlined
                        >
                            <v-card-title class="pb-0 pt-0 d-flex justify-center" style="font-size:0.7rem; height: 25px">
                                Median
                            </v-card-title>

                            <v-card-text class="text-center pb-0 text-h6 font-weight-bold px-0 primary--text">
                                <span :style="styleFontSize">{{  median  }}</span>
                            </v-card-text>
                        </v-card>

                        <v-card
                            height="60"
                            width="90"
                            flat
                            outlined
                        >
                            <v-card-title class="pb-0 pt-0 d-flex justify-center" style="font-size:0.7rem; height: 25px">
                                Average
                            </v-card-title>

                            <v-card-text class="text-center pb-0 text-h6 font-weight-bold px-0 primary--text">
                                <span :style="styleFontSize">{{  getStudentAverage  }}</span>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <!-- Music -->
        <v-row class="pl-3 mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card flat :width="width-12" outlined class="pa-2  mb-2 music-field">
                    <div class="d-flex justify-space-between align-end">
                        <v-card flat width="60" height="30" class="d-flex align-end">
                            <span class="font-weight-bold">Music</span>
                        </v-card>
                        <div 
                            class="d-flex"
                        >
    
                            <v-card                               
                                width="60"                                                                                                       
                                flat
                            >
                                <span class="text-caption-1">Late</span>
                                <v-text-field
                                    v-model="studentRecord['mlate']"
                                    dense 
                                    hide-details="auto" 
                                    outlined 
                                    height="20"
                                    class="text-caption pa-0"
                                    type="number"
                                    @blur="updateRecord"
                                    :disabled="disableMusic"
                                    :filled="disableMusic"
                                ></v-text-field>       
                            </v-card>
                        </div> 
    
                        <div 
                            class="d-flex"
                        >
    
                            <v-card                               
                                width="60"                                                                                                       
                                flat
                            >
                                <span class="text-caption-1">Abs</span>
                                <v-text-field
                                    v-model="studentRecord['mabs']"
                                    dense 
                                    hide-details="auto" 
                                    outlined 
                                    height="20"
                                    class="text-caption pa-0"
                                    type="number"
                                    @blur="updateRecord"
                                    :disabled="disableMusic"
                                    :filled="disableMusic"
                                ></v-text-field>       
                            </v-card>
                        </div>   
    
                    </div> 
    
                    <div class="d-flex justify-space-between">
                        
                        <div 
                            class="d-flex"
                        >
    
                            <v-card                               
                                width="80"                                                                                                       
                                flat
                            >
                                <span class="text-caption-1">Grade</span>
                                <v-select
                                    :items="grades"
                                    item-value="grade"
                                    v-model="studentRecord['mgrade']"
                                    hide-details="auto"
                                    outlined
                                    class="text-caption text-center no-padding"
                                    @change="updateRecord"
                                    small-chips
                                    :disabled="disableMusic"
                                    :filled="disableMusic"
                                >
                                    <template v-slot:selection="{ attrs, item }">
                                        <v-chip
                                            v-bind="attrs"
                                            close
                                            @click:close="removeGrade('mgrade')"
                                        >
                                            {{ item.grade }}
                                        </v-chip>
                                    </template>
    
                                    <template
                                        v-slot:item=data
                                    > 
                                        {{ data.item.grade }} {{ data.item.description }}
                                    </template> 
                                </v-select>    
                            </v-card>
                        </div> 
    
                        <div 
                            class="d-flex"
                        >
    
                            <v-card                               
                                width="80"                                                                                                       
                                flat
                            >
                                <span class="text-caption-1">App</span>
                                <v-select
                                    :items="grades"
                                    item-value="grade"
                                     v-model="studentRecord['mapp']"
                                    hide-details="auto"
                                    outlined
                                    class="text-caption text-center no-padding"
                                    @change="updateRecord"
                                    small-chips
                                    :disabled="disableMusic"
                                    :filled="disableMusic"
                                >
                                    <template v-slot:selection="{ attrs, item }">
                                        <v-chip
                                            v-bind="attrs"
                                            close
                                            @click:close="removeGrade('mapp')"
                                        >
                                            {{ item.grade }}
                                        </v-chip>
                                    </template>
    
                                    <template
                                        v-slot:item=data
                                    > 
                                        {{ data.item.grade }} {{ data.item.description }}
                                    </template> 
                                </v-select>      
                            </v-card>
                        </div>   
    
                        <div 
                            class="d-flex"
                        >
    
                            <v-card                               
                                width="80"                                                                                                       
                                flat
                            >
                                <span class="text-caption-1">Con</span>
                                <v-select
                                    :items="grades"
                                    item-value="grade"
                                    v-model="studentRecord['mcon']"
                                    hide-details="auto"
                                    outlined
                                    class="text-caption text-center no-padding"
                                    @change="updateRecord"
                                    small-chips
                                    :disabled="disableMusic"
                                    :filled="disableMusic"
                                >
                                    <template v-slot:selection="{ attrs, item }">
                                        <v-chip
                                            v-bind="attrs"
                                            close
                                            @click:close="removeGrade('mcon')"
                                        >
                                            {{ item.grade }}
                                        </v-chip>
                                    </template>
    
                                    <template
                                        v-slot:item=data
                                    > 
                                        {{ data.item.grade }} {{ data.item.description }}
                                    </template> 
                                </v-select>        
                            </v-card>
                        </div>   
    
                    </div>
    
                    <div class="d-flex mt-2">
                        <span class="text-caption-1 mr-2">Remarks</span>
                        <v-textarea
                            placeholder=" "
                            v-model="studentRecord['mcomments']"
                            rows="2"
                            class="text-caption"
                            no-resize
                            maxlength="255"
                            @blur="updateRecord"
                            outlined
                            dense
                            hide-details="auto"
                            :disabled="disableMusic"
                            :filled="disableMusic"
                        ></v-textarea>
                    </div>   
                </v-card>
            </v-col>           

        </v-row>

        <!-- Non academic records -->
        <v-row class="mr-0">
            <v-col class="flex-grow-0 pa-0">
                <v-card
                    :width="width"
                    flat
                >
                    <div>
                        <v-list class="py-0" dense>
                            <v-list-item
                                v-for="record in recordSummary4"
                                :key="record.title"
                                class="pr-0"
                            >
                                <v-list-item-content class="py-0">
                                    <v-list-item-title 
                                        class="text-caption"
                                    >
                                        {{ record.title }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-card                               
                                    width="120"                                                                                                       
                                    flat
                                >
                                    <v-select
                                        v-if="record.model == 'cocurricular'"
                                        v-model="selectedCoCurriculars"
                                        :disabled="record.disabled"
                                        :filled="record.disabled"
                                        :items="coCurriculars"
                                        item-value="detail"
                                        item-text="detail"
                                        multiple
                                        outlined
                                        hide-details="auto"
                                        class="text-caption text-center"
                                        @change="updateRecord"
                                    >
                                        <template v-slot:selection="{ index }">
                                            <!-- <span v-if="index === 0">{{ item.detail }}</span> -->
                                            <span
                                                v-if="index === 0" 
                                                class="text-caption grey--text"
                                            >
                                                ({{  selectedCoCurriculars.length }} Co-Curr.)
                                            </span>   
                                        </template>    
                                    </v-select>
                                    
                                    <v-select
                                        v-else
                                        v-model="studentRecord[record.model]"
                                        :disabled="record.disabled"
                                        :filled="record.disabled"
                                        :items="grades"
                                        item-value="grade"
                                        hide-details="auto"
                                        outlined
                                        class="text-caption text-center"
                                        @change="updateRecord"
                                        small-chips
                                    >
                                        <template v-slot:selection="{ attrs, item }">
                                            <v-chip
                                                v-bind="attrs"
                                                close
                                                tile
                                                @click:close="removeGrade(record.model)"
                                            >
                                                {{ item.grade }}
                                            </v-chip>
                                        </template>

                                        <template
                                            v-slot:item=data
                                        > 
                                            {{ data.item.grade }} {{ data.item.description }}
                                        </template> 
                                    </v-select>
                                </v-card> 
                            </v-list-item>
                        </v-list>
                    </div>
                                                    
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mr-0">
            <v-col class="">
                <v-row>
                    <v-col class="d-flex justify-space-between pr-5 py-0">
                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            @click="classMarkSheet"
                            :width="buttonWidth"
                        >
                            <span style="font-size: 0.6rem" >Class Mark Sheet</span>
                        </v-btn>
    
                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            :width="buttonWidth"
                            @click="rankSheet"
                        >
                            <span style="font-size: 0.6rem" >Rank Sheet</span>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="d-flex justify-space-between pr-5 pt-2 pb-0">
                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            :width="buttonWidth"
                            @click="displayReportCardsClass"
                        >
                            <span style="font-size: 0.6rem" >Print Class</span>
                        </v-btn>

                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            :width="buttonWidth"
                            @click="displayReportCard"
                        >
                            <span style="font-size: 0.6rem" >Print One</span>
                        </v-btn>

                    </v-col>
                </v-row>

                <v-row>
                    <v-col class="d-flex justify-space-between pr-5 pt-2 pb-0">
                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            :width="buttonWidth"
                            @click="enterMarks"
                            :disabled="!editTermReports"
                        >
                            <span style="font-size: 0.6rem" >Enter Marks</span>
                        </v-btn>

                        <v-btn
                            outlined
                            x-small
                            color="primary"
                            :width="buttonWidth"
                            @click="showMoreOptions"
                        >
                            <span style="font-size: 0.6rem" >More Options</span>
                        </v-btn>

                    </v-col>
                </v-row>
            </v-col>
        </v-row>

         <!-- More Options -->
        <v-dialog v-model="dialog" persistent width="300">
            <v-card>
                <v-card-title class="text-h6 grey lighten-2">
                    More Options
                </v-card-title>

                <v-btn
                    dark
                    color="error"
                    x-small
                    fab
                    style="position:absolute; top:10px; right:10px; z-index:100"
                    @click="dialog = !dialog"
                >
                    <v-icon dark>mdi-close</v-icon>
                </v-btn>


                <v-container fluid>
                    <v-row>            
                        <v-card flat  class="">
                            
            
                            <v-col class="pa-0 flex-grow-0">
                                <v-card
                                    flat
                                >
                                    <v-row 
                                        class="pl-3 ml-0 mb-1"
                                    >
                                        
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="ml-auto mr-3"
                                            style="font-size:0.55rem; text-align: center"
                                        >
                                            All Classes
                                        </v-card>
                                        <v-card 
                                            width="75" 
                                            flat 
                                            style="font-size:0.55rem"                           
                                        >
                                            Current Class
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0 mb-2">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            Possible Att.
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >
                                            <v-text-field                                
                                                v-model="possibleAttendanceAll"
                                                outlined
                                                hide-details
                                                dense
                                                style="font-size:0.7rem"
                                                type="number"
                                                @blur="changePossibleAttendance('All')"
                                                :disabled="!admin"
                                            ></v-text-field>
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat                            
                                        >
                                            <v-text-field
                                                v-model="studentRecord.possible_attendance"
                                                outlined
                                                hide-details
                                                dense
                                                style="font-size:0.7rem"
                                                type="number"
                                                @blur="changePossibleAttendance(studentRecord.class_id)"
                                                :disabled="!admin"
                                            ></v-text-field>
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0 mb-2">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            School Reopens
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >                            
                                            <date-picker 
                                                v-on:change-date="newTermDate($event,'All')"
                                                :disabled="!admin"                                
                                            ></date-picker>                           
                                        </v-card>
                                        <v-card 
                                            width="80"
                                            style="font-size:0.7rem" 
                                            flat                            
                                        >
                                            <date-picker 
                                                v-on:change-date="newTermDate($event, studentRecord.class_id)"
                                                v-bind:date="studentRecord.new_term_beginning"
                                                :disabled="!admin"
                                            ></date-picker> 
                                        </v-card>                       
                                    </v-row>
            
                                    <v-row class="pl-3 ml-0">
                                        <v-card 
                                            flat 
                                            style="font-size:0.7rem"
                                            class="mr-2"
                                            width="82"
                                        >
                                            Change Class
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat
                                            class="mr-2"
                                        >
                                            <v-select
                                                outlined
                                                hide-details
                                                dense
                                                :items="classes"
                                                class="change-class"
                                                style="font-size:0.6rem"
                                                v-model="studentRecord.class_id"
                                                @change="changeClass"
                                                :disabled="!admin"
                                            ></v-select>
                                        </v-card>
                                        <v-card 
                                            width="80" 
                                            flat                            
                                        >
                                            <v-btn                                
                                                color="primary"
                                                x-small
                                                height="30"
                                                block
                                                @click="deleteRecord"
                                                :disabled="!admin"                                
                                            >
                                                Delete
                                            </v-btn>
                                        </v-card>                       
                                    </v-row>
                                    
            
                                </v-card>
                            </v-col>

                        </v-card>
                    </v-row>
                </v-container>
                <v-card-actions class="mt-6">
                    <v-spacer></v-spacer>
                    <v-btn small depressed @click="dialog = !dialog">Close</v-btn>
                    <v-btn small color="primary">Update Options</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-col>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import DatePicker from './DatePicker.vue';
// import axios from 'axios'

export default {
    components: {
        DatePicker,
    },

    props: {
        median: [Number, String],
        rank: [Number, String],
    },
    
    created(){
        this.initialize();
    },

    computed: {
        ...mapGetters({
            studentRecord: 'termReports/getSelectedStudentRecord',            
            academicYear: 'termReports/getAcademicYear',
            currentTerm: 'termReports/getCurrentTerm',
            formTeacherClass: 'termReports/getFormTeacherClass',
            table1Records: 'termReports/getTable1Records',
            pagination: 'termReports/getPagination',
            formClasses: 'termReports/getFormClassesList',
            admin: 'auth/getAdmin',
            deanFormClasses: 'termReports/getDeanFormClasses',
            editTermReports: 'admin/getEditTermReports',
            table2Records: 'termReports/getEditViewTermReportsTable2Records',
            currentYear: 'termReports/getCurrentYear',   
            menuOptions: 'admin/getMenuOptions',
            accessToken: 'auth/getAccessToken', 
        }),

        studentName () {
            return this.studentRecord.first_name + ' ' + this.studentRecord.last_name;
        },

        classId () {
            return this.studentRecord.class_id;
        },
        recordSummary1 () {
            return this.recordSummary.filter(value => value.section == 1);
        },

        recordSummary2 () {
            return this.recordSummary.filter(value => value.section == 2);
        },

        recordSummary3 () {
            return this.recordSummary.filter(value => value.section == 3);
        },

        recordSummary4 () {
            return this.recordSummary.filter(value => value.section == 4);
        },

        termName () {
            let termName = '';
            if(this.currentTerm == 1) termName =  '1';
            if(this.currentTerm == 2) termName = '2';
            if(this.currentTerm == 3) termName = '3';
            return termName
        },

        getStudentAverage () {
            return isNaN(this.studentAverage) ? this.studentAverage : this.studentAverage + ' %';
        },

        
    },
    watch: {
        studentRecord: {
            handler (val) {
                this.selectedCoCurriculars = []; 
                if(val.cocurricular) this.selectedCoCurriculars = val.cocurricular.split(',');  
                this.setDisabledFields();
                this.setMusicAccess();
            }
        },

        table2Records: {
            deep: true,
            handler () {                                           
                this.getAverage();
            }
        },

    },
    data: () => ({
        recordSummary: [
            {title: 'Student\'s ID', model: 'student_id', select: false, disabled: true, section: 1},
            // {title: 'Possible Attendances', model: 'possible_attendance', select: false, disabled: true, section: 1},
            {title: 'Abs', model: 'times_absent', select: false, disabled: false, section: 2},
            {title: 'No. in class', model: 'no_in_class', select: false, disabled: false, section: 2},
            {title: 'Late', model: 'times_late', select: false, disabled: false, section: 3},
            {title: 'Rank', model: 'rank', select: false, disabled: false, section: 3},
            {title: 'Attitude to Authority', model: 'auth', select: true, disabled: false, section: 4},
            {title: 'Responsibility', model: 'resp', select: true, disabled: false, section: 4},
            {title: 'Co-Operation', model: 'coop', select: true, disabled: false, section: 4},
            {title: 'Co-Curricular Activities', model: 'cocurricular', select: true, disabled: false, section: 4},
        ],
        academicPeriod: [
            { title: 'Academic Year', value: '' },
            { title: 'Term', value: '' },
        ],
        grades: [
            { grade: 'A', description: 'Excellent'},
            { grade: 'B', description: 'Good'},
            { grade: 'C', description: 'Satisfactory'},
            { grade: 'D', description: 'Needs improvement'},
            { grade: 'E', description: 'Urgent Intervention Needed'},
        ],       
        options: {
            itemsPerPage: -1,
        },  
        disabled: false,
        expand: false,
        search: '',
        width: '280', 
        coCurriculars: [],
        selectedCoCurriculars: [],
       
        disableMusic: false,
        musicClasses: [],
        
        studentAverage: '',
        styleFontSize: '0.7rem',
        buttonWidth: '120px',
        possibleAttendanceAll: null,
        dialog: false,
        classes: [],
        newTermBeginningAll: '', 
    }),

    methods: {
        ...mapActions({ 
            postTable1Record: 'termReports/postTable1Record',
            getTable2Records: 'termReports/getTable2Records', 
            setErrorResponse: 'termReports/setErrorResponse',
            getCoCurriculars: 'termReports/getCoCurriculars',
            getMusicClasses: 'termReports/getMusicClasses',
            postChangeClass: 'admin/changeClass',
            getFormClasses: 'termReports/getClassesChangeClass',
            postPossibleAttendance: 'admin/postPossibleAttendance',
            postNewTermBeginning: 'admin/postNewTermBeginning',
            getTable1Record: 'termReports/getTable1Record',
        }), 

        ...mapMutations({         
            setSaveStatus: 'termReports/setEditViewTermReportsSaveStatus',
            setSaving: 'termReports/setEditViewTermReportsSaving',
            setSaveError: 'termReports/setEditViewTermReportsSaveError',
            setSaved: 'termReports/setEditViewTermReportsSaved',
            setOverlay: 'termReports/setEditViewTermReportsOverlay',
            setPagination: 'termReports/setPagination',           
            setLoading: 'termReports/setEditViewTermReportsLoading',
            setSelectedStudentRecord: 'termReports/setSelectedStudentRecord',
            setTable2Records: 'termReports/setEditViewTermReportsTable2Records',
            setStudentSubjects: 'termReports/setEditViewTermReportsStudentSubjects', 
            setExpand: 'termReports/setEditViewTermReportsExpand',
            overlay: 'termReports/setEditViewTermReportsOverlay',
            setSrc: 'termReports/setSrc',
            setEnterMarks: 'termReports/setEnterMarks',
            setExpandTerms: 'termReports/setExpandTerms',
            setSelectedTable1Record: 'admin/setSelectedTable1Record',
            setDialogDelete: 'admin/setDialogDelete',
            setPossibleAttendance: 'admin/setPossibleAttendance',
            setNewTermBeginning: 'admin/setNewTermBeginning',
            setChangeClassRecord: 'admin/setChangeClassRecord', 
            setMarkSheetOverlay: 'termReports/setMarkSheetOverlay', 
            setMarkSheetLoading: 'termReports/setMarkSheetLoading', 
            setSnackbar: 'admin/setSnackbar',
            setTable1Records: 'termReports/setTable1Records',
        }),

        async initialize(){ 
            this.academicPeriod[0].value = this.academicYear;
            this.academicPeriod[1].value = this.termName;
            try {
                // const { data } = await this.getCoCurriculars();
                const [
                    { data: dataCoCurriculars },
                    { data: dataMusicClasses },
                    { data: dataFormClasses },
                ] = await Promise.all([
                    this.getCoCurriculars(),
                    this.getMusicClasses(),
                    this.getFormClasses(),
                ])

                this.coCurriculars = dataCoCurriculars;
                this.setFormClasses(dataFormClasses);
                this.mapMusicClasses(dataMusicClasses)
                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }  
        },

        mapMusicClasses (data){
            data.forEach(element => {
                this.musicClasses.push(element.form_class_id)
            })
        },


        async updateRecord(){
            console.log('updating...');
            this.setSaveStatus('Saving...');
            this.setSaving(true);
            this.setSaved(false);
            this.setSaveError(false);
            this.studentRecord.cocurricular = this.selectedCoCurriculars.join(',');

            try{
                await this.postTable1Record();
                this.setSaveStatus('Record Saved');
                this.setSaving(false);
                this.setSaved(true);
                this.setSaveError(false);
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.setSaveStatus('Error Occured');
                this.setSaving(false);
                this.setSaved(false);
                this.setSaveError(true);
                this.setErrorResponse(error);
            }
            
        },


       

        cardWidth (item, index ){
            if(index == 1) return '100px';
            if(item.type == 'select') return '100px'
            return '65px'
        },

        setDisabledFields () {
            //default enable all fields
            this.disabled = false;
            this.disabledDeanComment = false;
            this.disableFormTeacherComment = false;

            this.recordSummary.forEach(element => {
                if(element.model != 'student_id')
                element.disabled = false;
            })

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && 
                !this.editTermReports
            ){
                this.disabled = true;
                this.disabledDeanComment = true;
                this.disableFormTeacherComment = true;
                this.recordSummary.forEach(element => {
                    element.disabled = true;
                })  
                console.log('enter 1');                  
                return;
            }

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) !== -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && 
                !this.editTermReports
            ){
                this.disabledDeanComment = true;
                console.log('enter 2');   
                return;
            }

            if(
                this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 &&
                this.deanFormClasses.indexOf(this.studentRecord.class_id) !== -1 && 
                !this.editTermReports
            ){
                this.recordSummary.forEach(element => {
                    element.disabled = true;
                })   
                console.log('enter 3');                    
                return;
            }

            //not the form teacher and dont have permission to edit
            // if(this.formTeacherClass.indexOf(this.studentRecord.class_id) === -1 && !this.editTermReports){
            //     //console.log('Not the form Teacher');
            //     this.disabled = true;
            //     this.disableFormTeacherComment = true;
            //     this.recordSummary.forEach(element => {
            //         element.disabled = true;
            //     })                    
            // }

            // if(this.deanFormClasses.length == 0){
            //     //not an assigned dean
            //     return;
            // }

            // if(this.deanFormClasses.indexOf(this.studentRecord.class_id) === -1 && !this.editTermReports){
            //     //console.log('Not the Assigned Dean');
            //     this.disabledDeanComment = true;
            //     this.disableFormTeacherComment = true;
            // }
           
            
            
        },

        nextClass () {
            this.setOverlay(true);
            this.setExpand(true);
        },

        checkNumber (model) {
            const validNumber = /^[0-9]+$/.test(this.studentRecord[model]);
            if(!validNumber){
                this.studentRecord[model] = null;
            }
        },

        removeGrade (model) {
            this.studentRecord[model] = null
            this.updateRecord();
        },

        setMusicAccess () {
            //open by default
            this.disableMusic = false;
            if(this.musicClasses.indexOf(this.studentRecord.class_id) === -1){
                this.disableMusic = true;
            }
        },

        getAverage(){
            this.styleFontSize = null;                   
            let recordCount = 0; 
            let totalMarks = 0;
            const { form_level } = this.studentRecord;
            
            this.table2Records.forEach(record => {
                recordCount++; 

                if( record.term == 1  && form_level > 4) {
                    totalMarks += record.course_mark ;
                }
                else if( record.term == 2  && form_level <= 4) {
                    totalMarks += record.course_mark;
                }
                else if( record.term == 2  && form_level > 4) {
                    totalMarks += record.exam_mark;
                }
                else{
                    totalMarks += record.course_mark*0.3 + record.exam_mark*1;
                }
                
            })
            

            if(recordCount != 0 ){               
                this.studentAverage =  (parseFloat(totalMarks.toFixed(2)) / recordCount).toPrecision(3);
            }
            else if(recordCount == 0) this.studentAverage = '--';
           
            
        },

        classMarkSheet () {
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });

            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/mark-sheet',
                report: 'mark-sheet',
                params: {
                    year: this.currentYear,
                    term: this.currentTerm,
                    classId: this.studentRecord.class_id,
                }               
            });

        },

        rankSheet () {            
            this.overlay(true);
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/rank-sheet',
                report: 'rank-sheet',
                params: {
                    year: this.currentYear,
                    term: this.currentTerm,
                    classId: this.studentRecord.class_id,
                }               
            });           
           
        },

        displayReportCard () {
            this.overlay(true);
            
            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/report-card',
                report: 'report-card',
                params: {
                    studentId: this.studentRecord.student_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                }               
            });  
        },

        displayReportCardsClass () {
            this.overlay(true);

            this.$nextTick(() => {
                this.setExpandTerms(true);
            });
            
            this.setSrc({
                baseUrl: process.env.VUE_APP_API_URI  + '/api/report-card',
                report: 'report-card',
                params: {
                    studentId: this.studentRecord.student_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                    report: 'report-card',
                    classId: this.studentRecord.class_id,               
                }
            });
        },

        enterMarks () {
            if(this.admin){
                 Object.keys(this.menuOptions).forEach(key => {
                    this.menuOptions[key] = false;
                })
                this.menuOptions["enterMarks"] = true;
            }
            else{                
                this.setEnterMarks(true);
                this.setEditViewTermReports(false);
                this.setMarkSheetOverlay(true);                    
                this.setMarkSheetLoading(true); 
            }
        },

        showMoreOptions () {
            this.dialog = true;
        },

        setFormClasses (data) {            
            data.forEach(value => {
                this.classes.push(value.id);
            });
        },

         async changeClass () {
            this.overlay(true);
            this.setLoading(true);            
            this.setChangeClassRecord({
                student_id: this.studentRecord.student_id,
                class_id: this.studentRecord.class_id
            })
            try {
                await this.postChangeClass();
                this.setSnackbar({
                    text: `Class changed to ${this.studentRecord.class_id}`,
                    display: true,
                    color: 'primary',
                });               
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSnackbar({
                    text: `Error occured`,
                    display: true,
                    color: 'red',
                });              
            }
            finally{
                this.setLoading(false);
                this.setOverlay(false);
            }         
        },

        async changePossibleAttendance (formClass) {
            this.setLoading(true);

            let snackbar = {};

            if(formClass == 'All'){
                this.studentRecord.possible_attendance = this.possibleAttendanceAll;
                this.setPossibleAttendance({
                    possible_attendance: this.possibleAttendanceAll,
                    class_id: null,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `Possible attendance set to ${this.possibleAttendanceAll} for all classes.`
                
            }
            else{
                this.setPossibleAttendance({
                    possible_attendance: this.studentRecord.possible_attendance,
                    class_id: this.studentRecord.class_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                })
                snackbar.text = `Possible attendance set to ${this.studentRecord.possible_attendance} for ${this.studentRecord.class_id}.`
            }

            try {
                await this.postPossibleAttendance();
                this.updateTable1Record();
                snackbar.color = 'primary';
                snackbar.display = true;
                this.setSnackbar(snackbar);  
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                snackbar.color= 'red';
                snackbar.display = true;
                snackbar.text = 'An Error Has Occured';
                this.setSnackbar(snackbar);
            } finally {
                this.setLoading(false);
                this.setOverlay(false);
            }
            
        },

        deleteRecord () {
            // console.log(this.table2Records);
            this.setSelectedTable1Record(this.studentRecord);
            if(this.table2Records.length != 0){
                this.setDialogDelete({
                    display: true,
                    text: 'Cannot delete record with existing subject records. Please delete all subject records first.',
                    cancel: false,
                    deleteSubject: false,
                    deleteStudent: false,
                    ok: true
                })
            }
            else{
                this.setDialogDelete({
                    display: true,
                    text: `Delete ${this.studentRecord.first_name} ${this.studentRecord.last_name} ?`,
                    cancel: true,
                    deleteSubject: false,
                    deleteStudent: true,
                    ok: false
                })
            }
        },

        async newTermDate (e, formClass) {
            this.setOverlay(true);
            this.setLoading(true);
            this.studentRecord.new_term_beginning = e;

            let snackbar = {};

            if(formClass == 'All'){
                this.setNewTermBeginning({
                    new_term_beginning: e,
                    class_id: null,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `New Term Beginning set to ${e} for all classes.`
            }
            else{
                this.setNewTermBeginning({
                    new_term_beginning: e,
                    class_id: this.studentRecord.class_id,
                    year: this.studentRecord.year,
                    term: this.studentRecord.term,
                });
                snackbar.text = `New Term Beginning set to ${e} for ${formClass}.`
            }
            // console.log(`Date: ${e}, class: ${formClass}`);

            try {
                await this.postNewTermBeginning();
                snackbar.color = 'primary';
                snackbar.display = true;
                this.setSnackbar(snackbar);  
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                snackbar.color= 'red';
                snackbar.display = true;
                snackbar.text = 'An Error Has Occured';
            }
            finally{
                this.setLoading(false);
                this.setOverlay(false);
            }
            
        },

        async updateTable1Record () {
            const { data } = await this.getTable1Record();
            this.setTable1Records(data.data);
        },

        
    },

    

   
}
</script>

<style scoped>
    ::v-deep .v-input__slot{
        min-height: 0px !important;
        display: flex !important;
        align-items: center !important;
    }

    ::v-deep .v-list--dense .v-list-item{
        min-height: 32px;
    }

    .v-btn__content{
        font-size: 0.9em;
    }

    ::v-deep .v-input__append-inner{
        margin-top: 0;
        padding-left: 0 !important;
    }

    ::v-deep .v-select__selections{
        height: 30px;
        /*padding: 0 !important;*/
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    ::v-deep .v-select__selection--comma{
        margin: 0 4px 4px 0;
    }

    ::v-deep .v-text-field__slot input{
        text-align: center;
    }

    ::v-deep .v-chip.v-size--default{
        height: 20px;
        font-size: 11px;
    }

    /* ::v-deep .times_late .v-chip.v-size--default{
        margin-top: 0;
    } */

    ::v-deep .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{
            min-height: 8px;
        }

    ::v-deep .v-select.v-select--chips .v-select__selections{
        min-height: 8px;
    }

    ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot{
        padding: 0;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-select__selections .v-chip{
        font-size: 10px;
        height: 20px;
    }

    ::v-deep .moral-education .v-input{
        width: 75px;
    }

    ::v-deep .moral-education .v-input .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-chip--select .v-chip__content .v-icon{
        margin-left: 2px;
    }

    ::v-deep .v-textarea textarea{
        line-height: 1rem;
    }

    /* ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 2px;
    } */

    /* ::v-deep .v-application--is-ltr .v-text-field .v-input__append-inner{
        padding-left: 0;
    }     */

          /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: none;   /* Chrome, Safari, and Edge */
    appearance: none;           /* Standard property */
    text-align: center; 
    }

    ::v-deep .text-caption-1{
        font-size: 0.65rem;
    }

    ::v-deep .no-padding.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
        padding: 0;
    }

    /* ::v-deep .v-text-field--outlined fieldset{
        top: -3px;
    } */

    ::v-deep .music-field.v-sheet.v-sheet--outlined{
        border-color: red;
    }

</style>